import { toRange } from '@studio/js-utils/range';

import type { Ambit } from '@studio/models/ptz';
import { Range as _Range, Threshold } from '@studio/models/ptz';
import Bezier from 'bezier-easing';
import type { Rate, Speed } from './types.js';
import { Facet, Pace } from './types.js';

/** Facet-specific ambits. */
export const Ambits = Object.freeze({
  [Facet.PanTilt]: {
    pan: true,
    tilt: true,
    zoom: false
  },

  [Facet.Zoom]: {
    pan: false,
    tilt: false,
    zoom: true
  },

  [Facet.TrackingSpeed]: {
    pan: true,
    tilt: false,
    zoom: false
  }
} satisfies Record<Facet, Ambit>);

/** Default easing function. */
export const DefaultEasing = Bezier(0, 0, 1, 1);

/** Default pace. */
export const DefaultPace = Pace.Medium;

/** Default axis rate. */
export const DefaultRate = Object.freeze({
  custom: false,
  pace: DefaultPace,
  value: (_Range.max * 3) / 4
} satisfies Rate);

/** Easing steps. */
export const EasingSteps = 12;

/** Quick shot movement speed. */
export const QuickShotSpeed = 0.1;

/** Speed range. */
export const Range = toRange(Threshold, _Range.max);

/** Pace-to-speed mapping. */
export const Speeds: Record<Facet, Record<Pace, Speed>> = {
  [Facet.TrackingSpeed]: {
    [Pace.Slow]: 0.05,
    [Pace.Medium]: 0.2,
    [Pace.Fast]: 0.5
  },
  [Facet.PanTilt]: {
    [Pace.Slow]: 0.05,
    [Pace.Medium]: 0.2,
    [Pace.Fast]: 0.5
  },
  [Facet.Zoom]: {
    [Pace.Slow]: 0.02,
    [Pace.Medium]: 0.25,
    [Pace.Fast]: 0.6
  }
};
